import { Input } from '@planuze/ui';
import { SearchIcon, XIcon } from 'lucide-react';
import type { JSX } from 'react';
import { useCommonContent } from '../content/sections/common.js';

interface SearchInputProps {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly ariaLabel: string;
  readonly placeholder?: string;
  readonly className?: string;
}

/* Campo de busca padrão do backoffice (ADR-0702): ícone à esquerda + botão de limpar à direita.
   Fonte única para a barra de pesquisa das listas — antes cada tela repetia (ou faltava) a busca. */
export function SearchInput({
  value,
  onChange,
  ariaLabel,
  placeholder,
  className,
}: SearchInputProps): JSX.Element {
  const copy = useCommonContent().searchInput;
  return (
    <div className={`relative w-full sm:max-w-xs ${className ?? ''}`}>
      <SearchIcon
        className="pointer-events-none absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground"
        aria-hidden="true"
      />
      <Input
        className="pl-8 pr-8"
        value={value}
        placeholder={placeholder ?? copy.defaultPlaceholder}
        aria-label={ariaLabel}
        onChange={(e) => onChange(e.target.value)}
      />
      {value.length > 0 && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label={copy.clearAriaLabel}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground transition-colors hover:text-foreground"
        >
          <XIcon className="size-3.5" aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
